/**
 * Bottom Tab Editor — default tab items, types, route options.
 *
 * Icon names must match keys in `lucide-react`'s `icons` export object.
 * E.g., "House" (not "Home"), "CircleAlert" (not "HelpCircle").
 */

export interface BottomTabItem {
  id: string
  icon: string
  label: string
  route: string
  visible: boolean
}

export const DEFAULT_TAB_ITEMS: BottomTabItem[] = [
  { id: 'tab-home', icon: 'House', label: 'หน้าแรก', route: '/', visible: true },
  { id: 'tab-categories', icon: 'LayoutGrid', label: 'หมวดหมู่', route: '/search', visible: true },
  { id: 'tab-search', icon: 'Search', label: 'ค้นหา', route: '/search', visible: true },
  { id: 'tab-cart', icon: 'ShoppingCart', label: 'ตะกร้า', route: '/cart', visible: true },
  { id: 'tab-account', icon: 'User', label: 'บัญชี', route: '/account', visible: true },
]

export const ROUTE_OPTIONS = [
  { value: '/', label: 'หน้าแรก (Home)' },
  { value: '/search', label: 'ค้นหา (Search)' },
  { value: '/cart', label: 'ตะกร้า (Cart)' },
  { value: '/account', label: 'บัญชี (Account)' },
  { value: '/coupons', label: 'คูปอง (Coupons)' },
  { value: '/favorites', label: 'รายการโปรด (Favorites)' },
] as const

export const LOCKED_ROUTE = '/cart' as const
export const MIN_VISIBLE_TABS = 3

/**
 * Hydrate server-returned tab items into the full BottomTabItem shape
 * needed by the editor UI and dnd-kit. Adds `id` (client-only, for
 * dnd-kit keys) and respects `visible` from server (defaults to true).
 */
export function hydrateTabItems(
  serverItems: Array<{ icon: string; label: string; route: string; visible?: boolean }> | null | undefined
): BottomTabItem[] {
  if (!serverItems?.length) return DEFAULT_TAB_ITEMS
  return serverItems.map((item, i) => ({
    id: `tab-${i}`,
    icon: item.icon,
    label: item.label,
    route: item.route,
    visible: item.visible ?? true,
  }))
}
